import { css } from '@emotion/react';
import { themed } from '@spotnana/blocks/src/utils';

export const warning_icon = themed(
  ({ palette }) => css`
    color: ${palette.text.secondary};
  `,
);
export const description = css`
  margin-left: 28px;
  margin-top: 4px;
`;
